//Third Party Libraries
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import type { ChangeEvent } from 'react';
import { twMerge } from 'tailwind-merge';

export default function TableFooterNav({
  currentPage,
  totalPage,
  perPage,
  perPageHandler,
  nextPage,
  previousPage,
}: {
  currentPage: number;
  totalPage: number;
  perPage?: number;
  perPageHandler: (perPage: number) => void;
  nextPage: () => void;
  previousPage: () => void;
}) {
  return (
    <div className='flex w-full justify-end py-5 border-t text-neutralColor-normal text-sm'>
      <div className='flex justify-around gap-8 items-end font-semibold px-5'>
        <div>
          Rows per page:{' '}
          <select
            className='bg-white border rounded-md px-2 py-1'
            onChange={(e: ChangeEvent<HTMLSelectElement>) => perPageHandler(Number(e.target.value))}
            value={perPage || 10}
          >
            <option value='5'>5</option>
            <option value='10'>10</option>
            <option value='25'>25</option>
            <option value='50'>50</option>
          </select>
        </div>

        <div>
          {currentPage} of {totalPage}
        </div>
        <div className='flex gap-4'>
          <div
            className={`cursor-pointer flex justify-center items-center rounded p-0.5 text-white ${
              currentPage === 1 ? 'bg-neutralColor-light' : 'bg-primaryColor-normal hover:bg-primaryColor-medium'
            }`}
            id='prev'
            onClick={previousPage}
          >
            <ChevronLeftIcon className='h-5 w-5' />
          </div>
          <div
            className={twMerge([
              'cursor-pointer flex justify-center items-center rounded p-0.5 text-white',
              currentPage === totalPage ? 'bg-neutralColor-light' : 'bg-primaryColor-normal hover:bg-primaryColor-medium',
            ])}
            onClick={nextPage}
          >
            <ChevronRightIcon className='h-5 w-5' />
          </div>
        </div>
      </div>
    </div>
  );
}
